import React from 'react';

const DocumentContext = React.createContext({});
export default DocumentContext;
